import type { BoardItem } from './board-labels';

/** Every task remains visible, including deeper derivations and malformed legacy cycles. */
export function orderBoardItems(items: BoardItem[]): Array<{ item: BoardItem; derived: boolean }> {
  const ids = new Set(items.map(item => item.id));
  const children = new Map<string, BoardItem[]>();
  for (const item of items) if (item.derivedFrom && ids.has(item.derivedFrom)) {
    children.set(item.derivedFrom, [...(children.get(item.derivedFrom) ?? []), item]);
  }
  const seen = new Set<string>();
  const result: Array<{ item: BoardItem; derived: boolean }> = [];
  const visit = (item: BoardItem, derived: boolean) => {
    if (seen.has(item.id)) return;
    seen.add(item.id); result.push({ item, derived });
    for (const child of children.get(item.id) ?? []) visit(child, true);
  };
  for (const item of items) if (!item.derivedFrom || !ids.has(item.derivedFrom)) visit(item, false);
  for (const item of items) visit(item, false);
  return result;
}
